import { firestoreAction } from 'vuexfire'
import { db } from '@/firebase/db'

const state = {
  inspect: [],
}

const getters = {

  inspect(state){
    return state.inspect
  },

  id: (state) => (id) => {
    return state.inspect.find(item => item.id == id)
  }
}

const mutations = {
  
}
/*
return db.collection('users').doc(project.owner).get().then(owner => {
              console.log('kake')
              return {...doc.data(), ...{owner: owner.data()}}
            })
*/

const actions = {

  inspect: firestoreAction(({ bindFirestoreRef, unbindFirestoreRef }, {id, type}) => { 
    console.log('id', id)
    if(type == 'user'){
      if(typeof id === "string"){
        return bindFirestoreRef('inspect', db.collection('projects').where('useraccess', 'array-contains', id)).then((projects) => {
          Promise.all(projects.map(project => {
            db.collection('users').doc(project.owner).get().then(owner => {
              project.owner = {...owner.data(), id: owner.id }
            })
          }))
        })
      }
      else if(typeof id === "object"){
        if(!id.length){
          unbindFirestoreRef('inspect')
          return []
        }
        return bindFirestoreRef('inspect', db.collection('projects').where('useraccess', 'array-contains-any', id)).then((projects) => {
          Promise.all(projects.map(project => {
            db.collection('users').doc(project.owner).get().then(owner => {
              project.owner = {...owner.data(), id: owner.id }
            })
          }))
        })
      }
    }
    else if(type == 'company'){
      console.log('get company by id')
      return bindFirestoreRef('inspect', db.collection('projects').where('companyID', '==', id))
    }
    else if(type == 'project'){
      return bindFirestoreRef('inspect', db.collection('projects').doc(id)).then(project => {
        console.log('projects.js' , project)
        db.collection('users').doc(project.owner).get().then(owner => {
          project.owner = {...owner.data(), id: owner.id }
        })
      })
    }
}),

  update: firestoreAction((context , {id, data}) => {
    return db.collection('projects').doc(id).update({...data})
  }),
  
  add: firestoreAction((context, project) => {
    console.log(context)
    return db.collection('projects').add(project)
  })
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}